import React from 'react';
import { UserForm } from '../components/UserForm';
import { useUserService } from '../hooks/useUserService';
import { container } from '../../shared/container/Container';
import type { IUserService } from '../../application/services/UserService';
import type { CreateUserRequest } from '../../domain/entities/User';

export const CreateUserPage: React.FC = () => {
  const userService = container.get<IUserService>('UserService');
  const { createUser, loading, error, clearError } = useUserService(userService);

  const handleSubmit = async (userData: CreateUserRequest): Promise<boolean> => {
    const success = await createUser(userData);
    if (success) {
      alert('User created successfully!');
      clearError();
    }
    return success;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Create New User</h1>
          <p className="mt-2 text-gray-600">Add a new user to the system</p>
        </div>
        
        <UserForm 
          onSubmit={handleSubmit}
          loading={loading}
          error={error}
        />
      </div>
    </div>
  );
};
